__turbopack_context__.v({
  "skip-link": "SkipLink-module-scss-module__mv13Xa__skip-link",
});
